import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData,
  type DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError,
  type DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse,
  deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete,
} from '../../generated';

export type DeleteCollectionMutationVariables =
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData['path'];

export type DeleteCollectionMutation =
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse;

export const useDeleteCollectionMutation = <
  TError = DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeleteCollectionMutation, TError, DeleteCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeleteCollectionMutation, TError, DeleteCollectionMutationVariables, TContext>({
    mutationKey: ['DeleteCollection'],
    mutationFn: async ({ portfolio_id, collection_id }: DeleteCollectionMutationVariables) => {
      const { data } = await deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete({
        path: { portfolio_id, collection_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeleteCollectionMutation.fetcher = (
  { portfolio_id, collection_id }: DeleteCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete({
      path: { portfolio_id, collection_id },
      throwOnError: true,
    });
    return data;
  };
};
